/**
 * AiCostsCard — Monatsuebersicht der KI-Erzeugungskosten (Bilder, Videos, Verlaengerungen).
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KIND_LABEL = { image: "🖼️ Bilder", video: "🎬 Videos", video_extend: "➕ Verlängerungen" };

export const AiCostsCard = ({ companyId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = {};
    if (companyId && companyId !== "all") params.company_id = companyId;
    axios.get(`${API}/ai/costs/summary`, { params, withCredentials: true })
      .then((r) => setData(r.data)).catch(() => setData(null));
  }, [companyId]);

  if (!data) return null;
  return (
    <Card className="border-[var(--studio-border)] shadow-none" data-testid="ai-costs-card">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-lg flex items-center justify-between">
          <span>💰 KI-Erzeugungskosten diesen Monat</span>
          <span className="text-xl" data-testid="ai-costs-month-total">~${data.month_total.toFixed(2)}</span>
        </CardTitle>
        <p className="text-xs text-[var(--studio-text-muted)]">
          Richtwerte deiner eigenen API-Konten (Veo ≈ $0.40/s · Runway ≈ $0.05/s · Verlängerung +7s ≈ $2.80 · Bild ≈ $0.04–0.06) — {data.count} Erzeugungen
        </p>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-4 text-sm">
          {Object.entries(data.by_kind).map(([k, v]) => (
            <span key={k} className="px-3 py-1.5 rounded-lg bg-[var(--studio-bg)] border border-[var(--studio-border)]">
              {KIND_LABEL[k] || k}: <b>~${v.toFixed(2)}</b>
            </span>
          ))}
          {data.count === 0 && <span className="text-xs text-[var(--studio-text-muted)]">Noch keine KI-Erzeugungen in diesem Monat.</span>}
        </div>
      </CardContent>
    </Card>
  );
};

export default AiCostsCard;
